const mutations = {
  set_status(state, status) {
    state.status = status
  },
  set_corpId(state, id) {
    state.corpId = id
  },
  set_channelInfo(state, info) {
    state.channelInfo = info
  },
  set_menuList(state, list) {
    state.menuList = list
  },
  set_advertTop(state, info) {
    state.advertTop = info
  },
  set_advertMiddle(state, info) {
    state.advertMiddle = info
  },
  set_userInfo(state, info) {
    state.userInfo = info
  },
  set_globalSetting(state, info) {
    state.globalSetting = info
  }
}
export default mutations
